import { amplitudeEventsLib } from '../amplitude-events';

export const quizBannerClick = () => {
  amplitudeEventsLib.quizBannerClick();
};

export const quizPageViewed = () => {
  amplitudeEventsLib.quizPageViewed();
};

export const quizQuestion = (params: { questionNumber: number }) => {
  amplitudeEventsLib.quizQuestion({
    number: params.questionNumber,
  });
};

export const quizNextQuestion = (params: { answer: string }) => {
  amplitudeEventsLib.quizNextQuestion({
    answer: params.answer,
  });
};

export const quizFinal = () => {
  amplitudeEventsLib.quizFinal();
};

export const takePromocodeClick = () => {
  amplitudeEventsLib.takePromocodeClick();
};

export const otherRoutesClick = () => {
  amplitudeEventsLib.otherRoutesClick();
};
